import { render, staticRenderFns } from "./update-role.vue?vue&type=template&id=aa50657a&scoped=true"
import script from "./update-role.vue?vue&type=script&lang=js"
export * from "./update-role.vue?vue&type=script&lang=js"
import style0 from "./update-role.vue?vue&type=style&index=0&id=aa50657a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa50657a",
  null
  
)

export default component.exports